import { useState } from 'react'

import { useRouter } from 'next/router'

import { validateSimpleString } from '@/utils/validations'

type TouchedProps = {
  [key: string]: boolean
}

export const useInputValidation = () => {
  const [touched, setTouched] = useState<TouchedProps>({} as TouchedProps)
  const router = useRouter()

  const handleBlur = (field: string) =>
    setTouched({ ...touched, [field]: true })

  const handleTouched = (field: string) =>
    setTouched({ ...touched, [field]: false })

  const handleErrorMessage = (
    field: string,
    value: string,
    customValidate?: (value: string) => boolean,
    customErrorMessage?: string,
  ) => {
    if (touched[field]) {
      if (!validateSimpleString(value)) {
        if (router.locale !== 'pt-BR') {
          return 'Required'
        }
        return 'Campo obrigatório'
      }
      if (customValidate && !customValidate(value)) return customErrorMessage
    }
    return null
  }

  const clearTouched = () => setTouched({})

  return {
    touched,
    setTouched,
    handleBlur,
    handleTouched,
    handleErrorMessage,
    clearTouched,
  }
}
